import { getClientIsMobile } from '@/utils/common';
import Vue, { VueConstructor } from 'vue';
import Modal from './modal.vue';
const CwModal = Modal as VueConstructor & {
  confirm: (props: ModalOption) => void;
  openInline: (props: ModalOption) => void;
};
export type ModalOption = {
  visible?: boolean;
  // 弹框类型
  type: string;
  // 提示标题
  title?: string;
  // 描述
  descript?: string;
  // 确认文本
  confirmText?: string | undefined;
  // 取消文本
  cancelText?: string | undefined;
  // 是否展示取消
  showCancel?: boolean;
  loading?: boolean;
  onOk?: Function;
  onCancel?: Function;
  // 调用失败时调用
  onFaild?: Function;
  // 遮罩展示
  maskClosable?: boolean;
  // 元素侧展示
  inline?: boolean;
  targetEl?: Element;
  // PC手动定位位置
  position?: 'top' | '';
};

CwModal.newInstance = () => {
  const component = new CwModal() as Vue &
    ModalOption & {
      open: Function;
    };
  component.$mount();

  document.body.appendChild(component.$el);

  return {
    show(props: ModalOption) {
      const newProps = { ...props, visible: true };
      component.open(newProps);
    },
    remove() {
      component.visible = false;
    }
  };
};

let modalInstance: Vue & { show: (props: ModalOption) => void };
CwModal.confirm = (props: ModalOption) => {
  if (props.inline && props.targetEl && !getClientIsMobile()) {
    CwModal.openInline(props);
    return;
  }
  modalInstance = modalInstance || CwModal.newInstance();
  modalInstance.show(props);
};

let component:
  | (Vue &
      ModalOption & {
        open: Function;
        handleClose: Function;
      })
  | undefined;
CwModal.openInline = (option: ModalOption) => {
  if (component) {
    component.handleClose();
    component = undefined;
  }
  let insetEl: HTMLDivElement | null = null;
  if (option.targetEl instanceof HTMLDivElement) {
    insetEl = option.targetEl;
  }
  if (!insetEl && option.targetEl?.parentElement instanceof HTMLDivElement) {
    insetEl = option.targetEl.parentElement;
  }
  if (!insetEl) return;

  component = new CwModal() as Vue &
    ModalOption & {
      open: Function;
      handleClose: Function;
    };
  component.$mount();
  insetEl.appendChild(component.$el);
  component.open(
    {
      ...option,
      visible: true
    },
    {
      closeHook: () => {
        try {
          component?.$el && insetEl?.removeChild(component.$el);
          // component?.$destroy();
        } catch (error) {}
      },
      insetEl
    }
  );
};

export default CwModal;
